import  { Component } from "react";

export default class UsersLocation extends Component {
  render() {
    return null;
  }
}
